import api from '../index';
import { ISupportInfo } from "@/api/support/interface";

export const $getSupportContact = (): Promise<ISupportInfo | null> => api
	.get('cbs/contact-info')
	.then(response => response || null);